import { render } from "./ManageUserDetailPage.vue?vue&type=template&id=4887cb7e&scoped=true"
import script from "./ManageUserDetailPage.vue?vue&type=script&lang=js"
export * from "./ManageUserDetailPage.vue?vue&type=script&lang=js"

import "./ManageUserDetailPage.vue?vue&type=style&index=0&id=4887cb7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4887cb7e"]])

export default __exports__